import Axios from "@/plugins/Axios";

export class AppConfigurationService {
  async getHikvisionStatus() {
    const response = await Axios().get("app-configurations/hikvision-status");
    return response.data;
  }

  async toggleHikvision(enabled) {
    const response = await Axios().post("app-configurations/toggle-hikvision", { enabled });
    return response.data;
  }

  async getNotifiqTabStatus() {
    const response = await Axios().get("app-configurations/notifiq-tab-status");
    return response.data;
  }

  async toggleNotifiqTab(enabled) {
    const response = await Axios().post("app-configurations/toggle-notifiq-tab", { enabled });
    return response.data;
  }

  async getNotifiqLancamentoStatus() {
    const response = await Axios().get("app-configurations/notifiq-lancamento-status");
    return response.data;
  }

  async toggleNotifiqLancamento(enabled) {
    const response = await Axios().post("app-configurations/toggle-notifiq-lancamento", {
      enabled,
    });
    return response.data;
  }
}

export default new AppConfigurationService();
